export default {
    form: {
        name: '',
        surname: '',
        invoice_number: '',
        street: '',
        city: '',
        zip: '',
        email: '',
        phone: '',
    },
    goods: [
        {
            good: '',
            photos: null,
            description: ''
        }
    ],
    gdpr: false,
    sending: false,
    sent: false,
    formType: 'claim',
    errors: {}
}
